import { trackVisit } from '@/firebase/analyticsService';

export default {
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        // Ensure we only track visits from the root instance to avoid duplicates
        // if this mixin is applied globally.
        if (this.$root === this && to && to.path) {
          trackVisit(to);
        }
      }
    }
  }
};

